/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
const standardPeoplePrice = process.env.REACT_APP_BITE_STANDARD_PEOPLE!;
const standardProductsPrice = process.env.REACT_APP_BITE_STANDARD_PRODUCTS!;
const standardFormsPrice = process.env.REACT_APP_BITE_STANDARD_FORMS!;
const standardPeoplePriceAnnual = process.env.REACT_APP_BITE_STANDARD_PEOPLE_ANNUAL!;
const standardProductsPriceAnnual = process.env.REACT_APP_BITE_STANDARD_PRODUCTS_ANNUAL!;
const standardFormsPriceAnnual = process.env.REACT_APP_BITE_STANDARD_FORMS_ANNUAL!;

const proPeoplePrice = process.env.REACT_APP_BITE_PRO_PEOPLE!;
const proProductsPrice = process.env.REACT_APP_BITE_PRO_PRODUCTS!;
const proFormsPrice = process.env.REACT_APP_BITE_PRO_FORMS!;
const proPeoplePriceAnnual = process.env.REACT_APP_BITE_PRO_PEOPLE_ANNUAL!;
const proProductsPriceAnnual = process.env.REACT_APP_BITE_PRO_PRODUCTS_ANNUAL!;
const proFormsPriceAnnual = process.env.REACT_APP_BITE_PRO_FORMS_ANNUAL!;

const entPeoplePrice = process.env.REACT_APP_BITE_ENT_PEOPLE!;
const entProductsPrice = process.env.REACT_APP_BITE_ENT_PRODUCTS!;
const entFormsPrice = process.env.REACT_APP_BITE_ENT_FORMS!;
const entPeoplePriceAnnual = process.env.REACT_APP_BITE_ENT_PEOPLE_ANNUAL!;
const entProductsPriceAnnual = process.env.REACT_APP_BITE_ENT_PRODUCTS_ANNUAL!;
const entFormsPriceAnnual = process.env.REACT_APP_BITE_ENT_FORMS_ANNUAL!;

export const standardMeterPriceGroup = {
  people: {
    price: standardPeoplePrice,
    metadata: {
      type: 'meter',
      moduleName: 'People'
    }
  },
  products: {
    price: standardProductsPrice,
    metadata: {
      type: 'meter',
      moduleName: 'Products'
    }
  },
  forms: {
    price: standardFormsPrice,
    metadata: {
      type: 'meter',
      moduleName: 'Forms'
    }
  }
};

export const standardMeterPriceGroupAnnual = {
  people: {
    price: standardPeoplePriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'People'
    }
  },
  products: {
    price: standardProductsPriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'Products'
    }
  },
  forms: {
    price: standardFormsPriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'Forms'
    }
  }
};

export const proMeterPriceGroup = {
  people: {
    price: proPeoplePrice,
    metadata: {
      type: 'meter',
      moduleName: 'People'
    }
  },
  products: {
    price: proProductsPrice,
    metadata: {
      type: 'meter',
      moduleName: 'Products'
    }
  },
  forms: {
    price: proFormsPrice,
    metadata: {
      type: 'meter',
      moduleName: 'Forms'
    }
  }
};

export const proMeterPriceGroupAnnual = {
  people: {
    price: proPeoplePriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'People'
    }
  },
  products: {
    price: proProductsPriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'Products'
    }
  },
  forms: {
    price: proFormsPriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'Forms'
    }
  }
};

export const entMeterPriceGroup = {
  people: {
    price: entPeoplePrice,
    metadata: {
      type: 'meter',
      moduleName: 'People'
    }
  },
  products: {
    price: entProductsPrice,
    metadata: {
      type: 'meter',
      moduleName: 'Products'
    }
  },
  forms: {
    price: entFormsPrice,
    metadata: {
      type: 'meter',
      moduleName: 'Forms'
    }
  }
};

export const entMeterPriceGroupAnnual = {
  people: {
    price: entPeoplePriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'People'
    }
  },
  products: {
    price: entProductsPriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'Products'
    }
  },
  forms: {
    price: entFormsPriceAnnual,
    metadata: {
      type: 'meter',
      moduleName: 'Forms'
    }
  }
};
